import React, { useEffect } from "react";
import Input from "@/Components/Input";
import { Head, Link, useForm } from "@inertiajs/inertia-react";
import SelectInput from "@/Components/SelectInput";
import ValidationErrors from "@/Components/ValidationErrors";
export default function Example() {
    const { data, setData, post, processing, errors, reset } = useForm({
        email: "",
        phone: "",
        name: "",
        address: "",
        city: "",
        zip: "",
    });

    useEffect(() => {
        return () => {
            reset("password");
        };
    }, []);

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.value);
    };

    const submit = (e) => {
        e.preventDefault();

        post(route("order.store-temp"));
    };

    return (
        <>
            <div className="h-screen flex bg-black">
                <div className="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
                    <div className="mx-auto w-full max-w-sm lg:w-96">
                        <div>
                            <h2 className="mt-2 text-5xl text-white font-custom italic font-bold uppercase">
                                Je bent er bijna
                            </h2>
                        </div>

                        <div className="mt-8">
                            <div className="mt-6">
                                <ValidationErrors errors={errors} />

                                <form
                                    onSubmit={submit}
                                    method="POST"
                                    className="space-y-6"
                                >
                                    <div>
                                        <Input
                                            type="text"
                                            name="email"
                                            value={data.email}
                                            className="mt-1 block w-full"
                                            label="E-mailadres"
                                            autoComplete="email"
                                            handleChange={onHandleChange}
                                        />
                                    </div>

                                    <div>
                                        <Input
                                            type="text"
                                            name="phone"
                                            value={data.phone}
                                            className="mt-1 block w-full"
                                            label="Telefoonnummer"
                                            autoComplete="phone"
                                            handleChange={onHandleChange}
                                        />
                                    </div>

                                    <div className="space-y-1">
                                        <Input
                                            type="text"
                                            name="name"
                                            value={data.name}
                                            className="mt-1 block w-full"
                                            label="Volledige naam"
                                            autoComplete="name"
                                            handleChange={onHandleChange}
                                        />
                                    </div>

                                    <div className="space-y-1">
                                        <Input
                                            type="text"
                                            name="address"
                                            value={data.address}
                                            className="mt-1 block w-full"
                                            label="Adres"
                                            autoComplete="address"
                                            handleChange={onHandleChange}
                                        />
                                    </div>

                                    <div className="space-y-1">
                                        <Input
                                            type="text"
                                            name="zip"
                                            value={data.zip}
                                            className="mt-1 block w-full"
                                            label="Postcode"
                                            autoComplete="zip"
                                            handleChange={onHandleChange}
                                        />
                                    </div>

                                    <div className="space-y-1">
                                        <Input
                                            type="text"
                                            name="city"
                                            value={data.city}
                                            className="mt-1 block w-full"
                                            label="Woonplaats"
                                            autoComplete="city"
                                            handleChange={onHandleChange}
                                        />
                                    </div>

                                    <div>
                                        <button
                                            type="submit"
                                            className="uppercase inline-flex items-center justify-center cursor-pointer px-4 py-3 border border-transparent text-sm font-medium rounded-md shadow-sm text-black bg-we-are-yellow hover:text-white hover:bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2"
                                        >
                                            Bestellen
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="hidden lg:block relative w-0 flex-1">
                    <picture>
                        <source
                            srcSet="/assets/webp/personal-training-schijndel-uden.webp"
                            type="image/webp"
                            alt="Succesvol afvallen zonder voedingsschema quote"
                            className="absolute inset-0 h-full w-full object-cover"
                        />
                        <source
                            srcSet="/assets/personal-training-schijndel-uden.jpg"
                            type="image/jpeg"
                            alt="Succesvol afvallen zonder voedingsschema quote"
                            className="absolute inset-0 h-full w-full object-cover"
                        />
                        <img
                            src="/assets/personal-training-schijndel-uden.jpg"
                            alt="Succesvol afvallen zonder voedingsschema quote"
                            className="absolute inset-0 h-full w-full object-cover"
                        />
                    </picture>
                </div>
            </div>
        </>
    );
}
